const BaseView = require('../abstract-element-options');

module.exports = BaseView.extend({
  template: require('./template.hbs'),

  initialize: function (options) {
    BaseView.prototype.initialize.call(this, options);
  },

  render: function () {
    this.$el.html(this.template());
    this.initReplacementPanel({
      colors: this.colors.length > 0 && [{ palette: [...this.colors] }]
    });
  },

  replaceItem: function (asset) {
    if (!asset.source) {
      return;
    }
    const selectedElement = INKIVE.DesignFacade.getSelectedElements()[0];

    if (asset.action === 'color_replace') {
      INKIVE.DesignFacade.set(selectedElement.id, { fill: { color: asset.source } });
    }
  }
});
